import React from 'react';
import styled from 'styled-components';
import coeur1 from '../assets/images/bgicons/coeur1.svg';
import coeur2 from '../assets/images/bgicons/coeur2.svg';
import coeur3 from '../assets/images/bgicons/coeur3.svg';
import coeur4 from '../assets/images/bgicons/coeur4.svg';

const HEARTS = [coeur1, coeur2, coeur3, coeur4];

// Dispositions pré-réglées (position, taille, rotation, opacité, cœur).
// Plusieurs variantes pour que deux sections voisines ne se ressemblent pas.
const LAYOUTS = [
  [
    { src: 0, top: '-4%', left: '-3%', size: 180, rot: -12, op: 0.30 },
    { src: 2, top: '40%', right: '4%', size: 130, rot: 14, op: 0.30 },
    { src: 3, bottom: '-6%', left: '32%', size: 150, rot: 8, op: 0.30 },
  ],
  [
    { src: 1, top: '8%', right: '-2%', size: 200, rot: 10, op: 0.30 },
    { src: 3, bottom: '-8%', left: '-2%', size: 160, rot: -8, op: 0.30 },
    { src: 0, top: '30%', left: '46%', size: 110, rot: 18, op: 0.30 },
  ],
  [
    { src: 2, top: '-6%', left: '20%', size: 150, rot: -16, op: 0.30 },
    { src: 1, bottom: '4%', right: '8%', size: 175, rot: 12, op: 0.30 },
    { src: 3, top: '34%', left: '-4%', size: 120, rot: -6, op: 0.30 },
  ],
];

const TONES = {
  white: '#FFFFFF',
  yellow: '#FFDD00',
  chocolate: '#4A2600',
};

// Décor de fond : cœurs Tartina flottants, derrière le contenu.
const SectionBg = ({ tone = 'chocolate', variant = 0 }) => {
  const layout = LAYOUTS[variant % LAYOUTS.length];
  const color = TONES[tone] || TONES.chocolate;
  return (
    <Layer aria-hidden="true">
      {layout.map((h, i) => (
        <Heart
          key={i}
          $src={HEARTS[h.src]}
          $color={color}
          style={{
            top: h.top,
            left: h.left,
            right: h.right,
            bottom: h.bottom,
            width: h.size,
            height: h.size,
            opacity: h.op,
            transform: `rotate(${h.rot}deg)`,
          }}
        />
      ))}
    </Layer>
  );
};

const Layer = styled.div`
  position: absolute;
  inset: 0;
  z-index: -1;
  overflow: hidden;
  pointer-events: none;
`;
// Note : le parent doit être en position: relative. À -1, le calque se peint
// au-dessus du fond de la section mais sous le contenu (qui reste en flux).

const Heart = styled.span`
  position: absolute;
  display: block;
  background-color: ${({ $color }) => $color};
  -webkit-mask: url(${({ $src }) => $src}) center / contain no-repeat;
  mask: url(${({ $src }) => $src}) center / contain no-repeat;

  @media (max-width: 768px) {
    transform: scale(0.7) !important;
  }
`;

export default SectionBg;
